<template>
  <v-main>
    <v-container fluid>
      <v-row no-gutters>
        <v-col cols="12">
          <DataTable
            @editing="editing"
            :title="title"
            :headers="headers"
            :items="companies"
          />
        </v-col>
      </v-row>
    </v-container>
    <v-btn dark fab fixed bottom right large color="pink" class="mx-2" @click="addCourse">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  </v-main>
</template>


<script>
import { mapGetters } from "vuex";
import store from "@/store";
import DataTable from "@/components/datatable/datatable";
import { FETCH_COMPANIES, COMPANIES_RESET_STATE } from "@/store/actions.type";
import { SET_LOADING } from "@/store/mutations.type";
export default {
  name: "Companies",
  async beforeRouteUpdate(to, from, next) {
    await store.commit(SET_LOADING, true)
    await store.dispatch(COMPANIES_RESET_STATE);
    return next();
  },
  async beforeRouteEnter(to, from, next) {
    await store.dispatch(COMPANIES_RESET_STATE);
    await store.dispatch(FETCH_COMPANIES, "").then(resp =>{
      if(resp.success){
        store.commit(SET_LOADING, false)
      }
    })

    return next();
  },
  async beforeRouteLeave(to, from, next) {
    await store.commit(SET_LOADING, true)
    await store.dispatch(COMPANIES_RESET_STATE);
    next();
  },
  computed: {
    ...mapGetters(["companies"])
  },
  components: {
    DataTable
  },
  data: function() {
    return {
      title: "Companies",
      headers: [
        { text: 'Company Prefix', value: 'company_prefix'},
        { text: 'Company Name', value: 'company_name' },
        { text: 'Account Type', value: 'account_type' },
        { text: 'Available Seats', value: 'available_seats' },
        { text: 'Domain', value: 'company_domain' },
        { text: 'Status', value: 'company_status' },
        { text: 'Actions', value: 'action', sortable: false },
      ],
    };
  },
  methods: {
    editing(id) {
      this.$router.push("/company/edit/" + id);
    },
    addCourse() {
      this.$router.push("/company/add/");
    }
  }
};
</script>